import { Link } from 'react-router-dom'
import { Home, Search, ArrowLeft } from 'lucide-react'
import { Helmet } from 'react-helmet-async'

export default function NotFoundPage() {
  return (
    <div className="flex-1 flex items-center justify-center p-4 bg-hs-bg">
      <Helmet>
        <title>Page Not Found - Headstate Studio</title>
      </Helmet>
      
      <div className="max-w-md w-full text-center">
        <div className="relative mb-12">
          <div className="text-[12rem] font-display font-bold leading-none text-white opacity-[0.03] select-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
             <div className="w-24 h-24 neu-panel rounded-full flex items-center justify-center border-white/10 shadow-glossy">
                <Search size={40} className="text-hs-edge drop-shadow-[0_0_15px_rgba(255,107,107,0.4)]" />
             </div>
          </div>
        </div>

        <h1 className="text-4xl font-display font-bold text-white mb-4 tracking-tighter text-gloss">
          PAGE NOT FOUND
        </h1>
        <p className="text-hs-text mb-12 font-light leading-relaxed">
          The coordinates you've entered lead to deep space. The requested page has moved or never existed.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/dashboard"
            className="neu-button px-8 py-4 flex items-center justify-center text-xs font-mono font-bold text-white uppercase tracking-widest bg-hs-core/10 border-hs-core/20"
          >
            Go to Dashboard
          </Link>
          <Link
            to="/"
            className="neu-button px-8 py-4 flex items-center justify-center text-xs font-mono font-bold text-hs-text hover:text-white uppercase tracking-widest"
          >
            <ArrowLeft size={14} className="mr-2" />
            Home Base
          </Link>
        </div>
      </div>
    </div>
  )
}
